import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "data-transfers"
    }}>{`Data Transfers`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Blob.md"
        }}>{`Blob`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Clipboard.md"
        }}>{`Clipboard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "fetch.md"
        }}>{`fetch`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FormData.md"
        }}>{`FormData`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Headers.md"
        }}>{`Headers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Request.md"
        }}>{`Request`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Response.md"
        }}>{`Response`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "WebSocket.md"
        }}>{`WebSocket`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "XMLHttpRequest.md"
        }}>{`XMLHttpRequest`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      